import { jsxs as v, jsx as s } from "react/jsx-runtime";
import { forwardRef as I, useRef as u, useMemo as w, useImperativeHandle as C, useCallback as p } from "react";
import c from "./styles.module.less.js";
import N from "./calendar.svg.js";
const S = I((o, d) => {
  var i;
  const { value: r, disabled: t, onChange: l, error: f } = o, e = u(null), m = u(null), h = w(() => {
    if (r && !isNaN(r))
      return new Date(r).toISOString().split("T")[0];
    if (r)
      try {
        return new Date(r).toISOString().split("T")[0];
      } catch {
        try {
          const a = r.split("-").reverse().join("-");
          return new Date(a).toISOString().split("T")[0];
        } catch (a) {
          console.error(a);
        }
      }
    return "";
  }, [r]);
  C(d, () => e.current, []);
  const g = p(
    (n) => {
      if (!t) {
        const a = n.target.value;
        l(a);
      }
    },
    [t, l]
  ), k = p(
    (n) => {
      if (n.stopPropagation(), !t && e.current)
        if (e.current.focus(), e.current.showPicker)
          try {
            e.current.showPicker();
          } catch {
            console.debug("showPicker not supported, using click fallback"), e.current.click();
          }
        else
          e.current.click();
    },
    [t]
  );
  return /* @__PURE__ */ v(
    "div",
    {
      ref: m,
      className: `${c.dateInputWrapper}`,
      onClick: k,
      children: [
        /* @__PURE__ */ s(
          "input",
          {
            ref: e,
            ...o.props,
            className: `${c.dateInput} ${((i = o.props) == null ? void 0 : i.className) || ""} ${f ? c.error : ""}`,
            type: "date",
            value: h,
            onChange: g,
            disabled: t
          }
        ),
        /* @__PURE__ */ s("div", { className: c.calendarIcon, children: /* @__PURE__ */ s(N, {}) })
      ]
    }
  );
});
S.displayName = "DateInput";
export {
  S as DateInput
};
